import { FirestoreGenerationStatus } from "reedy-data/models";

/**
 * The maximum amount of books that can be selected
 * for generating metadata
 */
export const GENERATE_METADATA_BOOKS_LIMIT = 50;

/**
 * The ceiling on how many books a single bulk action can touch: saving them as
 * a project, exporting them, or fetching a whole result set to act on. Searches
 * that exist to feed a bulk action size their page to this on purpose, so the
 * entire actionable set lands on one page.
 */
export const BULK_BOOKS_LIMIT = 250;

/**
 * The amount of books that can be selected for project creation,
 * before we trigger a warning dialog, explaining that the
 * project might be hard to manage.
 */
export const SAVE_AS_PROJECT_BOOKS_WARNING_LIMIT = 100;

/**
 * The amount of books that can be updated at once
 * in the generateKeywords and generateDescriptions functions
 * 500 is the firebase limit, BULK_BOOKS_LIMIT caps us lower anyways
 */
export const BATCH_SIZE = 500;

/**
 * The maximum amount of characters that should be used in the keywords field
 * according to amazon's requirements
 */
export const MAX_KEYWORDS_CHARACTERS_COUNT = 500;

/**
 * The maximum amount of words that should be used in the book description field
 * according to amazon's requirements
 */
export const MAX_BOOK_DESCRIPTION_WORDS_COUNT = 300;

/**
 * The current version of our terms and conditions
 */
export const TERMS_AND_CONDITIONS_VERSION = "1.0.0";

/**
 * The FirestoreGenerationStatus that are considered completed
 */
export const COMPLETED_STATUSES: FirestoreGenerationStatus[] = [
  FirestoreGenerationStatus.COMPLETED,
  FirestoreGenerationStatus.ERROR,
  FirestoreGenerationStatus.CANCELLED,
];

export const GENERAL_AUDIENCE_TARGET = "reedy-general-audience-default";
